import { ref, reactive, toRefs } from "@vue/composition-api"

import { restEdge } from "@/api/edgeUrls";
import api from "@/api";
import { fromArrayKeys } from '@/lib/transformer'

const _fetchDataOptions = async () => {
  const { data, status } = await api.get(restEdge.formGeneric, {
    needToken: true,
    useRestEdge: true
  });

  if(status == 200) {
    return data
  } 
}

const _createVehicle= async (title) => {
  let body = {
    title: title
  };
  const response = await api.post(restEdge.createVehicle, body, {
    needToken: true,
    useRestEdge: true
  });
  
  return response
}

export default () => {
  // Data
  const options = reactive({
    vehicles: [],
    routes: [],
    schemes: [
      {
        id: 0,
        label: "Day",
        value: "day"
      },
      {
        id: 1,
        label: "Week",
        value: "week"
      },
      {
        id: 2,
        label: "Month",
        value: "month"
      }
    ],
    time: [
      {
        id: 0,
        label: "Day",
        value: "day"
      },
      {
        id: 1,
        label: "Week",
        value: "week"
      },
      {
        id: 2,
        label: "Month",
        value: "month"
      },
      {
        id: 3,
        label: "Year",
        value: "year"
      }
    ]
  })


  // Methods
  const getOptions = async () => {
    const data = await _fetchDataOptions()
    const { vehicles, routes } = fromArrayKeys(data)
    options.vehicles = vehicles
    options.routes = routes
  }

  const addVehicles = async (title) => {
    const { status } = await _createVehicle(title)

    if (status == 200){
      getOptions()
    }
  }

  return { getOptions, options, addVehicles }
}